"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2835],{

/***/ 434825:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var uuid = __webpack_require__(596839);

const WIDTH_ECOM_BROCHURES = 596;
const HEIGHT_ECOM_BROCHURES = 842;
const DEFAULT_ECOM_BROCHURES_DATA = {
  showCover: false,
  showNavigation: true,
  flippingTime: 1e3,
  drawShadow: true,
  images: [
    {
      src: "https://lh3.googleusercontent.com/bCZSa-1lUXv-CGmZg0kn-djOXSMJySMij_sW8DRSI9a4Q9y9dghOHBS5AWsuWolCgxlplm4xpEqPig60Wu7Dl-qK_7jwHR4=rw-v1-w1188-h1602",
      googleImageParams: {
        width: 0
      }
    },
    {
      src: "https://lh3.googleusercontent.com/iQf7e9QwnjnXQQvaY-k9UuJJhEMINU5VgF2v8y4QFNk9w6QfIgRzDcBHEAX_jNGAAkHDvkAiJYf7zVKhcXsMidszX5i3Zbw=rw-v1-w1188-h1602",
      googleImageParams: {
        width: 0
      }
    },
    {
      src: "https://lh3.googleusercontent.com/pP-g3rCYE2ZSgOittIYwtjdFya6RQc94SePoAWY85fg-8l9PC5Q8sQXg4w-0rm9XAyY27yrcMX0Eng7nAl2CdEZyJUpYRgU=rw-v1-w1188-h1602",
      googleImageParams: {
        width: 0
      }
    },
    {
      src: "https://lh3.googleusercontent.com/cS2uEO6dSgEysQ3ulMJzc9hR5jde4IN51UviDsxnBjGgsHNu_lmI8UWp6uKPl9YqPLMR-RqHeNSY9y-fS4y7IRvIhlVcU_4=rw-v1-w1188-h1602",
      googleImageParams: {
        width: 0
      }
    },
    {
      src: "https://lh3.googleusercontent.com/Nco1qkMlmee-Y7jBdBCW5kP41UofzGjLaMmtcPldciuqKk2ao-QnoFRTa3d-YAbnr0rUZD5LcbfcZx-0BzHydz94cpUa5mA7=rw-v1-w1188-h1602",
      googleImageParams: {
        width: 0
      }
    },
    {
      src: "https://lh3.googleusercontent.com/cS2uEO6dSgEysQ3ulMJzc9hR5jde4IN51UviDsxnBjGgsHNu_lmI8UWp6uKPl9YqPLMR-RqHeNSY9y-fS4y7IRvIhlVcU_4=rw-v1-w1188-h1602",
      googleImageParams: {
        width: 0
      }
    }
  ],
  items: [
    {
      id: uuid.v4(),
      src: "https://lh3.googleusercontent.com/MZjjgQKS-5hIvZ68Zc92VMDDJNLrNdStPZqt4g6VXPRrWHf5-WtWAwWavJRBiyin464cZNfzOZyfHd9B9n-W97LFMImuqZaK=rw-v1-w1188-h1602"
    }
  ]
};

exports.DEFAULT_ECOM_BROCHURES_DATA = DEFAULT_ECOM_BROCHURES_DATA;
exports.HEIGHT_ECOM_BROCHURES = HEIGHT_ECOM_BROCHURES;
exports.WIDTH_ECOM_BROCHURES = WIDTH_ECOM_BROCHURES;


/***/ }),

/***/ 748349:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var Draggable = __webpack_require__(886168);
var coreEditor = __webpack_require__(476674);
var reactIcons = __webpack_require__(959211);
var propKey = __webpack_require__(394005);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Draggable__default = /*#__PURE__*/_interopDefaultLegacy(Draggable);

const DraggableItemEditor = ({
  width,
  height,
  EBrochuresItemIndex,
  blockIndex,
  ratio = 1
}) => {
  const [positionX, setPositionX] = coreEditor.usePropSeparateDevice(
    propKey.PROP_KEY.joinKey(
      propKey.PROP_KEY.Items,
      EBrochuresItemIndex.toString(),
      propKey.PROP_KEY.Blocks,
      blockIndex.toString(),
      "x"
    )
  );
  const [positionY, setPositionY] = coreEditor.usePropSeparateDevice(
    propKey.PROP_KEY.joinKey(
      propKey.PROP_KEY.Items,
      EBrochuresItemIndex.toString(),
      propKey.PROP_KEY.Blocks,
      blockIndex.toString(),
      "y"
    )
  );
  const trackPos = (data) => {
    setPositionY(data.y);
    setPositionX(data.x);
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Draggable__default["default"], {
    allowAnyClick: true,
    bounds: "parent",
    position: { x: positionX * ratio || 0, y: positionY * ratio || 0 },
    onStop: (e, data) => {
      e.preventDefault();
      trackPos(data);
    },
    children: /* @__PURE__ */ jsxRuntime.jsx("div", {
      style: {
        width: Number(width),
        height: Number(height),
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        position: "absolute",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      children: /* @__PURE__ */ jsxRuntime.jsx(reactIcons.AddCircleFilled, {
        fontSize: 24,
        color: "white"
      })
    })
  });
};

exports.DraggableItemEditor = DraggableItemEditor;


/***/ }),

/***/ 119164:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var Draggable = __webpack_require__(886168);
var reactIcons = __webpack_require__(959211);
var styled = __webpack_require__(212951);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Draggable__default = /*#__PURE__*/_interopDefaultLegacy(Draggable);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const DraggableItemRender = ({
  width,
  height,
  x,
  y,
  link
}) => {
  return /* @__PURE__ */ jsxRuntime.jsx(Draggable__default["default"], {
    allowAnyClick: true,
    bounds: "parent",
    position: { x, y },
    disabled: true,
    children: /* @__PURE__ */ jsxRuntime.jsx(StyledContainer, {
      onClick: () => {
        if (!!link) {
          window.open(link, "_blank");
        }
      },
      width: Number(width),
      height: Number(height),
      children: /* @__PURE__ */ jsxRuntime.jsx(reactIcons.AddCircleFilled, {
        fontSize: 24,
        color: "white"
      })
    })
  });
};
const StyledContainer = styled__default["default"].div(
  ({ width, height }) => `
    width: ${width}px;
    height: ${height}px;
    background-color: rgba(0, 0, 0, 0.75);
    position: absolute;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    &:hover {
        opacity: 1;
    }
  `
);

exports.DraggableItemRender = DraggableItemRender;


/***/ }),

/***/ 765040:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);
var React = __webpack_require__(891987);
var HTMLFlipBook = __webpack_require__(447670);
var constants = __webpack_require__(434825);
var DraggableItemEditor = __webpack_require__(748349);
var DraggableItemRender = __webpack_require__(119164);
var Container = __webpack_require__(739890);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var HTMLFlipBook__default = /*#__PURE__*/_interopDefaultLegacy(HTMLFlipBook);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EcomBrochures = (props) => {
  const _a = props, { isEditingMode, items } = _a, restProps = __objRest(_a, ["isEditingMode", "items"]);
  const { device } = coreRenderer.useStore();
  const isMobile = device === "mobile";
  const { commonStyle } = coreRenderer.getPropsByDevice(restProps, device);
  const { padding, margin } = commonStyle || {};
  const wrapperRef = React.useRef(null);
  const [widthWrapper, setWidthWrapper] = React.useState(0);
  React.useEffect(() => {
    if (!wrapperRef.current)
      return;
    const el = wrapperRef.current;
    const updateWidth = () => {
      var _a2;
      const width = (_a2 = el == null ? void 0 : el.getBoundingClientRect()) == null ? void 0 : _a2.width;
      if (width)
        setWidthWrapper(Math.round(width));
    };
    const debouncedUpdateWidth = isEditingMode ? coreRenderer.debounce(updateWidth, 200) : updateWidth;
    const observer = new ResizeObserver(() => {
      debouncedUpdateWidth();
    });
    requestAnimationFrame(() => {
      debouncedUpdateWidth();
    });
    observer.observe(el);
    return () => {
      observer.disconnect();
    };
  }, [isEditingMode, isMobile, wrapperRef.current]);
  const isDoubleItem = widthWrapper >= 2 * constants.WIDTH_ECOM_BROCHURES;
  const ratio = widthWrapper >= constants.WIDTH_ECOM_BROCHURES ? 1 : widthWrapper / constants.WIDTH_ECOM_BROCHURES;
  const {
    images,
    showCover: showCoverRest,
    flippingTime,
    drawShadow
  } = restProps;
  const pageFlipRef = React.useRef();
  const [showCover, setShowCover] = React.useState(showCoverRest || false);
  const [isMoving, setIsMoving] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(showCoverRest ? 0 : 1);
  const [shouldAutoFlip, setShouldAutoFlip] = React.useState(false);
  const [isReturningToCover, setIsReturningToCover] = React.useState(false);
  const [pageFlipKey, setPageFlipKey] = React.useState(0);
  const finalWidth = constants.WIDTH_ECOM_BROCHURES;
  const finalHeight = constants.HEIGHT_ECOM_BROCHURES;
  const bookWidth = finalWidth * 2;
  const totalImages = (images == null ? void 0 : images.length) || 0;
  const canGoPrev = showCoverRest ? currentPage > 0 : currentPage > 1;
  const canGoNext = currentPage < totalImages - 2;
  const shouldShowNavigation = restProps.showNavigation !== false && totalImages > 1;
  const coverImage = !!showCoverRest && (images == null ? void 0 : images.length) > 0 ? images[0] : null;
  const shouldShowCover = showCoverRest && showCover && coverImage;
  const handleCoverClick = () => {
    if (showCoverRest && showCover && !isMoving) {
      setIsMoving(true);
      setShouldAutoFlip(true);
      setTimeout(() => {
        setShowCover(false);
        setIsMoving(false);
      }, 600);
    }
  };
  const handleFlip = (e) => {
    setCurrentPage(e.data);
    if (showCoverRest && e.data === 0 && !showCover && !isReturningToCover) {
      setIsReturningToCover(true);
      setTimeout(() => {
        setShowCover(true);
        setIsReturningToCover(false);
      }, 600);
    }
  };
  const handlePrevPage = () => {
    var _a2;
    if ((pageFlipRef == null ? void 0 : pageFlipRef.current) && canGoPrev) {
      (_a2 = pageFlipRef == null ? void 0 : pageFlipRef.current) == null ? void 0 : _a2.pageFlip().flipPrev();
    }
  };
  const handleNextPage = () => {
    var _a2;
    if (currentPage === 0 && showCoverRest) {
      handleCoverClick();
    } else if ((pageFlipRef == null ? void 0 : pageFlipRef.current) && canGoNext) {
      (_a2 = pageFlipRef == null ? void 0 : pageFlipRef.current) == null ? void 0 : _a2.pageFlip().flipNext();
    }
  };
  React.useEffect(() => {
    setPageFlipKey((key) => key + 1);
    if (showCoverRest && !showCover) {
      setShowCover(true);
    }
  }, [drawShadow, flippingTime, showCoverRest]);
  React.useEffect(() => {
    if (showCoverRest && shouldAutoFlip && pageFlipRef.current && !showCover) {
      const timer = setTimeout(() => {
        try {
          pageFlipRef.current.pageFlip().flipNext();
          setShouldAutoFlip(false);
        } catch (error) {
          console.warn("Could not auto flip page:", error);
        }
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [shouldAutoFlip, showCover, showCoverRest]);
  const navigation = shouldShowNavigation && !isMobile && totalImages > 1 && /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(NavigationArrow, {
        position: "left",
        onClick: handlePrevPage,
        disabled: !canGoPrev,
        children: "\u2039"
      }),
      /* @__PURE__ */ jsxRuntime.jsx(NavigationArrow, {
        position: "right",
        onClick: handleNextPage,
        disabled: currentPage !== 0 && !canGoNext,
        children: "\u203A"
      })
    ]
  });
  const FlipBookContentMobile = /* @__PURE__ */ jsxRuntime.jsx("div", {
    style: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    children: images == null ? void 0 : images.map((image, imageIndex) => {
      const { src, blocks = [] } = image;
      return /* @__PURE__ */ jsxRuntime.jsx("div", {
        style: {
          width: constants.WIDTH_ECOM_BROCHURES * ratio,
          position: "relative",
          backgroundImage: `url('${src}')`,
          backgroundSize: "contain",
          height: constants.HEIGHT_ECOM_BROCHURES * ratio,
          backgroundPosition: "center"
        },
        children: blocks.map(
          ({ width = 50, height = 50, x, y, link }, blockIndex) => {
            return isEditingMode ? /* @__PURE__ */ jsxRuntime.jsx(DraggableItemEditor.DraggableItemEditor, {
              width: Number(width) * ratio,
              height: Number(height) * ratio,
              EBrochuresItemIndex: imageIndex,
              blockIndex,
              ratio
            }) : /* @__PURE__ */ jsxRuntime.jsx(DraggableItemRender.DraggableItemRender, {
              link,
              width: Number(width) * ratio,
              height: Number(height) * ratio,
              x: !Number.isNaN(Number(x)) ? Number(x) * ratio : 0,
              y: !Number.isNaN(Number(y)) ? Number(y) * ratio : 0
            });
          }
        )
      });
    })
  });
  const FlipBookContent = /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      shouldShowCover && !isMobile && /* @__PURE__ */ jsxRuntime.jsx(CoverContainer, {
        onClick: handleCoverClick,
        width: finalWidth,
        height: finalHeight,
        isMoving,
        children: /* @__PURE__ */ jsxRuntime.jsx(Page, {
          src: coreRenderer.getImageUrlFromGoogleUserContent((coverImage == null ? void 0 : coverImage.src) || "", __spreadValues({
            format: "webp"
          }, coverImage.googleImageParams)),
          width: finalWidth,
          height: finalHeight
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsx(FlipBookContainer, {
        isReturningToCover,
        isHidden: !!shouldShowCover && !isMobile,
        bookWidth,
        bookHeight: finalHeight,
        children: /* @__PURE__ */ jsxRuntime.jsx(HTMLFlipBook__default["default"], __spreadProps(__spreadValues({
          ref: pageFlipRef
        }, restProps), {
          flippingTime: restProps.flippingTime > 0 ? restProps.flippingTime : constants.DEFAULT_ECOM_BROCHURES_DATA.flippingTime,
          width: finalWidth,
          height: finalHeight,
          minWidth: finalWidth,
          maxWidth: finalWidth,
          minHeight: finalHeight,
          maxHeight: finalHeight,
          mobileScrollSupport: true,
          drawShadow: restProps.drawShadow !== false,
          onFlip: handleFlip,
          children: images == null ? void 0 : images.map((image, imageIndex) => {
            const { src = "", googleImageParams, blocks = [] } = image;
            return /* @__PURE__ */ jsxRuntime.jsx(Page, {
              src: coreRenderer.getImageUrlFromGoogleUserContent(src, __spreadValues({
                format: "webp"
              }, googleImageParams)),
              width: finalWidth,
              height: finalHeight,
              children: blocks.map(
                ({ width = 50, height = 50, x, y, link }, blockIndex) => {
                  return isEditingMode ? /* @__PURE__ */ jsxRuntime.jsx(DraggableItemEditor.DraggableItemEditor, {
                    width: Number(width),
                    height: Number(height),
                    EBrochuresItemIndex: imageIndex,
                    blockIndex,
                    ratio: 1
                  }) : /* @__PURE__ */ jsxRuntime.jsx(DraggableItemRender.DraggableItemRender, {
                    link,
                    width: Number(width),
                    height: Number(height),
                    x: !Number.isNaN(Number(x)) ? Number(x) : 0,
                    y: !Number.isNaN(Number(y)) ? Number(y) : 0
                  });
                }
              )
            }, imageIndex);
          })
        }), pageFlipKey)
      })
    ]
  });
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, {
    commonStyle: {
      padding,
      margin,
      width: "100%"
    },
    maxWidth: 2 * constants.WIDTH_ECOM_BROCHURES,
    children: /* @__PURE__ */ jsxRuntime.jsxs("div", {
      style: {
        position: "relative",
        maxWidth: 2 * constants.WIDTH_ECOM_BROCHURES,
        width: "100%"
      },
      ref: wrapperRef,
      children: [
        navigation,
        isDoubleItem ? FlipBookContent : FlipBookContentMobile
      ]
    })
  });
};
EcomBrochures.displayName = "Omni_EBrochures";
const NavigationArrow = styled__default["default"].button(
  ({ position, disabled }) => `
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${position === "left" ? "left: 0px;" : "right: 0px;"}
  visibility: ${disabled ? "hidden" : "visible"};

  width: 30px;
  height: 30px;
  border: none;
  color: #333;
  font-size: 56px;
  font-weight: bold;
  background-color: transparent;
  color:rgb(190, 190, 190);

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.2s ease;
  z-index: 10;

  &:hover {
    ${!disabled ? `
      background-color: transparent;
      transform: translateY(-50%) scale(1.05);
      color: #ffffff;
    ` : ""}
  }

  &:active {
    ${!disabled ? `
      transform: translateY(-50%) scale(0.95);
      color: #ffffff;
    ` : ""}
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    font-size: 20px;
    ${position === "left" ? "left: 0px;" : "right: 0px;"}
  }
`
);
const CoverContainer = styled__default["default"].div(
  ({ width, height, isMoving }) => `
  width: ${width}px;
  height: ${height}px;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0; /* Prevent shrinking */

  &:hover {
    ${!isMoving ? "transform: scale(1.02);" : ""}
  }

  ${isMoving ? `transform: translateX(50%);` : ""}
`
);
const Page = styled__default["default"].div(
  ({ src, width, height }) => `
  position: relative;
  width: ${width};
  height: ${height};
  background-repeat: no-repeat;
  background-image: url(${src});
  background-size: contain;
  background-position: center;
`
);
const FlipBookContainer = styled__default["default"].div(
  ({ isReturningToCover, isHidden, bookWidth, bookHeight }) => `
  position: relative;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);

  /* Force exact dimensions for book container */
  width: ${bookWidth}px !important;
  height: ${bookHeight}px !important;
  min-width: ${bookWidth}px !important;
  min-height: ${bookHeight}px !important;
  flex-shrink: 0;

  /* Force all child elements to use exact dimensions */
  .stf__parent {
    width: ${bookWidth}px !important;
    min-width: ${bookWidth}px !important;
    max-width: ${bookWidth}px !important;
    height: ${bookHeight}px !important;
    min-height: ${bookHeight}px !important;
    max-height: ${bookHeight}px !important;
  }

  .stf__wrapper {
    width: ${bookWidth}px !important;
    height: ${bookHeight}px !important;
    padding-bottom: 0 !important;
  }

  .stf__block {
    width: ${bookWidth}px !important;
    height: ${bookHeight}px !important;
  }

  ${isHidden ? `
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  ` : ""}

  ${isReturningToCover ? `
    transform: translateX(-25%);
  ` : ""}
`
);

exports.EcomBrochures = EcomBrochures;


/***/ }),

/***/ 241995:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);
var constants = __webpack_require__(324735);
var utils = __webpack_require__(646085);
var image = __webpack_require__(698791);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const imageDefault = image.generatePlaceholderImage({ width: 300, height: 400 });
const ArticleItem = (props) => {
  var _a, _b;
  const { device, globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  const {
    title,
    category,
    src: imageUrl,
    googleImageParams,
    itemStyle,
    description,
    displayConfig,
    event,
    isEditingMode
  } = props;
  const {
    showCategory = true,
    showTitle = true,
    showDescription = true
  } = displayConfig || {};
  const isMobile = device === "mobile";
  const linkArticle = (_a = event == null ? void 0 : event.link) == null ? void 0 : _a.href;
  const {
    borderRadius = 0,
    descriptionColor,
    titleColor,
    categoryColor
  } = __spreadValues(__spreadValues({}, constants.ARTICLE_ITEM_STYLE), utils.cleanObj(itemStyle));
  const totalContentRow = (_b = [showCategory, showTitle, showDescription].filter(
    Boolean
  )) == null ? void 0 : _b.length;
  const handleClickUrl = (url, target = "_blank") => {
    if (!url || isEditingMode || isPreviewMode)
      return;
    window.open(url, target);
  };
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    rel: "noreferrer",
    totalShowRows: totalContentRow + 1,
    isMobile,
    isEditingMode,
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.ImageBase, {
        commonStyle: {
          width: isMobile ? 150 : 300,
          objectFit: "fill",
          marginLeft: "auto",
          marginRight: "auto",
          height: isMobile ? 200 : 400,
          borderRadius
        },
        src: imageUrl || imageDefault,
        googleImageParams,
        event
      }),
      /* @__PURE__ */ jsxRuntime.jsxs(ContentWrapper, {
        gridRow: totalContentRow,
        children: [
          showCategory && category && /* @__PURE__ */ jsxRuntime.jsx(CategoryWrapper, {
            children: /* @__PURE__ */ jsxRuntime.jsx(Category, {
              color: categoryColor,
              children: category
            })
          }),
          showTitle && /* @__PURE__ */ jsxRuntime.jsx(Title, {
            onClick: () => handleClickUrl(linkArticle),
            style: { color: titleColor },
            children: title
          }),
          showDescription && /* @__PURE__ */ jsxRuntime.jsx(Description, {
            style: { color: descriptionColor },
            children: description
          })
        ]
      })
    ]
  });
};
const Wrapper = styled__default["default"].div(
  ({ totalShowRows, rowGap, commonStyle, isEditingMode }) => `
    display: grid;
    width: fit-content;
    grid-template-rows: subgrid;
    grid-row: span ${totalShowRows};
    grid-row-gap: ${rowGap}px;
    ${isEditingMode ? `
      a {
        pointer-events: none;
      }
    ` : ""}
    ${coreRenderer.getStyle(commonStyle)}
    `
);
const ContentWrapper = styled__default["default"].div(
  ({ gridRow }) => `
    margin-top: 4px;
    width: 100%;
    display: grid;
    grid-template-rows: subgrid;
    grid-row: span ${gridRow};
`
);
const Title = styled__default["default"].p`
  font-weight: 600;
  line-height: 22px;
  font-size: 14px;
  cursor: pointer;
  ${utils.getClampedTextStyle(3)}
`;
const Description = styled__default["default"].p`
  font-weight: 400;
  line-height: 20px;
  font-size: 12px;
  ${utils.getClampedTextStyle(3)}
`;
const Category = styled__default["default"].div(
  ({ color, commonStyle }) => `
   color: ${color};
  background-color: ${coreRenderer.generate(color)["50"]};
  border: ${coreRenderer.generate(color)["200"]} 1px solid;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 400;
  line-height: 20px;
  font-size: 12px;
  width: fit-content;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const CategoryWrapper = styled__default["default"].div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`;

exports.ArticleItem = ArticleItem;


/***/ }),

/***/ 324735:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var style = __webpack_require__(629909);
var image = __webpack_require__(698791);
var grid = __webpack_require__(793767);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const BASE_ARTICLE_LIST_DATA = {
  title: "C\u1EA9m nang mua s\u1EAFm",
  titleColor: "#000000",
  viewMoreStyle: {
    color: "#000000"
  },
  items: [
    {
      src: "https://lh3.googleusercontent.com/HeYzLy2ooplcdEqDCWeT7jm-UO3woKaqOMxxa2rBmvt-jxapAf9Scx5kmnagEoXYAj84y6PBm2bxXEwxyHGmvpXOZaAjFjdm",
      googleImageParams: {
        width: 300
      },
      event: {
        eventType: "link",
        link: {
          href: "https://cooponline.vn/"
        }
      },
      title: "C\u1EA9m nang mua s\u1EAFm Co.op Online",
      category: "Co.opmart - TP.HCM",
      description: "28/05/2025 - 11/06/2025"
    },
    {
      src: "https://lh3.googleusercontent.com/BU0Bc9XOkQC1RM65KwO6cTX0EEihRzDq1JhrWuawgX3o8xNHdOu7hZpjHZ2l0tQIW_H8CVhjvQpF_0WZVBVQ1xonpJZmb3zN",
      googleImageParams: {
        width: 300
      },
      event: {
        eventType: "link",
        link: {
          href: "https://cooponline.vn/"
        }
      },
      title: "C\u1EA9m nang mua s\u1EAFm Co.op Online",
      category: "Co.opmart - TP.HCM",
      description: "28/05/2025 - 11/06/2025"
    },
    {
      src: image.generatePlaceholderImage({ width: 300, height: 400 }),
      googleImageParams: {
        width: 300
      },
      event: {
        eventType: "link",
        link: {
          href: "https://cooponline.vn/"
        }
      },
      title: "C\u1EA9m nang mua s\u1EAFm Co.op Online",
      category: "Co.opmart - TP.HCM",
      description: "28/05/2025 - 11/06/2025"
    }
  ],
  displayConfig: {
    showCategory: true,
    showTitle: true,
    showDescription: true
  },
  maxWidth: grid.DEFAULT_MAX_WIDTH
};
const ARTICLE_ITEM_STYLE = {
  titleColor: "#000000",
  categoryColor: "#1677FF",
  descriptionColor: "#000000A6",
  borderRadius: 8
};
const DEFAULT_ARTICLE_LIST = __spreadProps(__spreadValues({}, BASE_ARTICLE_LIST_DATA), {
  itemStyle: ARTICLE_ITEM_STYLE,
  desktop: {
    commonStyle: __spreadValues({}, style.DESKTOP_COMMON_STYLE)
  },
  mobile: {
    commonStyle: __spreadProps(__spreadValues({}, style.MOBILE_COMMON_STYLE), {
      padding: {
        left: 0,
        right: 0
      }
    })
  }
});

exports.ARTICLE_ITEM_STYLE = ARTICLE_ITEM_STYLE;
exports.DEFAULT_ARTICLE_LIST = DEFAULT_ARTICLE_LIST;


/***/ }),

/***/ 609656:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var jsxRuntime = __webpack_require__(561261);
var React = __webpack_require__(891987);
var styled = __webpack_require__(212951);
var coreRenderer = __webpack_require__(327723);
var icons = __webpack_require__(225956);
var ArticleItem = __webpack_require__(241995);
var constants = __webpack_require__(324735);
var utils = __webpack_require__(646085);
var Container = __webpack_require__(739890);
var Slider = __webpack_require__(699332);
var grid = __webpack_require__(793767);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OmniArticleList = (props) => {
  const { device, globalData } = coreRenderer.useStore();
  const isPreviewMode = globalData == null ? void 0 : globalData.isPreviewMode;
  const isMobile = device === "mobile";
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const [showNavBtns, setShowNavBtns] = React.useState(false);
  const _a = props, {
    isEditingMode,
    title,
    viewMoreUrl,
    items = [],
    itemStyle,
    viewMoreStyle,
    titleColor = constants.DEFAULT_ARTICLE_LIST.titleColor,
    displayConfig
  } = _a, restProps = __objRest(_a, [
    "isEditingMode",
    "title",
    "viewMoreUrl",
    "items",
    "itemStyle",
    "viewMoreStyle",
    "titleColor",
    "displayConfig"
  ]);
  const _b = coreRenderer.getPropsByDevice(restProps, device), {
    commonStyle,
    maxWidth = grid.DEFAULT_MAX_WIDTH
  } = _b, rest = __objRest(_b, [
    "commonStyle",
    "maxWidth"
  ]);
  const _c = commonStyle || {}, { padding, margin } = _c, restStyle = __objRest(_c, ["padding", "margin"]);
  const { displayItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const handleClickUrl = (url, target = "_blank") => {
    if (!url || isEditingMode || isPreviewMode)
      return;
    window.open(url, target);
  };
  if (!(displayItems == null ? void 0 : displayItems.length) && !isEditingMode)
    return null;
  return /* @__PURE__ */ jsxRuntime.jsx(Container.Container, __spreadProps(__spreadValues({
    commonStyle: { maxWidth, padding, margin },
    maxWidth
  }, rest), {
    children: /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
      commonStyle: __spreadValues({ backgroundSize: "cover" }, restStyle),
      style: { padding: "8px 16px", borderRadius: 8 },
      children: [
        /* @__PURE__ */ jsxRuntime.jsxs(TitleWrapper, {
          children: [
            /* @__PURE__ */ jsxRuntime.jsx(TitleStyled, {
              style: { color: titleColor },
              children: title
            }),
            viewMoreUrl && /* @__PURE__ */ jsxRuntime.jsxs(ViewAll, {
              style: {
                color: (viewMoreStyle == null ? void 0 : viewMoreStyle.color) || constants.DEFAULT_ARTICLE_LIST.viewMoreStyle.color
              },
              onClick: () => handleClickUrl(viewMoreUrl),
              children: [
                "Xem t\u1EA5t c\u1EA3 ",
                /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
                  style: { fontSize: 16 },
                  name: "RightOutlined"
                })
              ]
            })
          ]
        }),
        isMobile ? /* @__PURE__ */ jsxRuntime.jsx(ArticleListWrapper, {
          isEditingMode,
          children: displayItems.map((item, index) => /* @__PURE__ */ React.createElement(ArticleItem.ArticleItem, __spreadProps(__spreadValues({}, item), {
            key: index,
            itemStyle,
            isEditingMode,
            displayConfig
          })))
        }) : /* @__PURE__ */ jsxRuntime.jsxs("div", {
          onMouseEnter: () => setShowNavBtns(true),
          onMouseLeave: () => setShowNavBtns(false),
          style: { position: "relative" },
          children: [
            (displayItems == null ? void 0 : displayItems.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(NavigationButtonStyled, {
              className: "left-nav",
              style: { opacity: showNavBtns ? 1 : 0 },
              ref: navigationPrevRef
            }),
            /* @__PURE__ */ jsxRuntime.jsx(SliderWrapper, {
              navigation: {
                prevEl: navigationPrevRef.current,
                nextEl: navigationNextRef.current
              },
              slidesPerView: "auto",
              navigationStyle: 1,
              paginationColor: "#ffffff",
              allowTouchMove: !isEditingMode,
              onBeforeInit: (swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRef.current;
                swiper.params.navigation.nextEl = navigationNextRef.current;
              },
              spaceBetween: 16,
              children: displayItems.map((item, index) => /* @__PURE__ */ React.createElement(ArticleItem.ArticleItem, __spreadProps(__spreadValues({}, item), {
                key: index,
                itemStyle,
                isEditingMode,
                displayConfig
              })))
            }),
            (displayItems == null ? void 0 : displayItems.length) > 1 && /* @__PURE__ */ jsxRuntime.jsx(NavigationButtonStyled, {
              className: "right-nav",
              style: { opacity: showNavBtns ? 1 : 0 },
              ref: navigationNextRef
            })
          ]
        })
      ]
    })
  }));
};
OmniArticleList.displayName = "Omni_ArticleList";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)}
`
);
const TitleStyled = styled__default["default"].div`
  ${utils.getClampedTextStyle(1)}
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  margin: 0 16px 0 0;
`;
const ArticleListWrapper = styled__default["default"].div(
  ({ isEditingMode }) => `
  display: grid;
  grid-auto-flow: column;
  width: fit-content;
  width: 100%;
  row-gap: 4px;
  column-gap: 12px;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    height: 8px;
    ${!isEditingMode ? "display: none;" : ""}
  }

  &::-webkit-scrollbar-track {
    border-radius: 12px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }
`
);
const NavigationButtonStyled = styled__default["default"].div`
  top: 200px;
  position: absolute;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 100px;
  background-color: white;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2);
  &:after {
    content: ' ';
    height: 30px;
    width: 30px;
    display: inline-block;
    background: #333;
  }

  &.left-nav {
    transform: translateY(-50%) translateX(-50%);
    left: 0px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
      mask-size: contain;
    }
  }

  &.right-nav {
    transform: translateY(-50%) translateX(50%);
    right: 0px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
      mask-size: contain;
    }
  }

  &.swiper-button-disabled {
    display: none;
  }
`;
const TitleWrapper = styled__default["default"].div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;
const ViewAll = styled__default["default"].div`
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
`;
const SliderWrapper = styled__default["default"](Slider.Slider)`
  .swiper-wrapper {
    display: grid;
    grid-auto-flow: column;
    width: fit-content;
    row-gap: 4px;
  }

  .swiper-slide {
    display: grid;
    grid-template-rows: subgrid;
    grid-row: span 4;
  }
`;

exports.OmniArticleList = OmniArticleList;


/***/ }),

/***/ 646085:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

const cleanObj = (obj) => Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== void 0));
const getClampedTextStyle = (lines) => `
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  line-clamp: ${lines};
  -webkit-box-orient: vertical;
  line-height: 1.5;
`;

exports.cleanObj = cleanObj;
exports.getClampedTextStyle = getClampedTextStyle;


/***/ })

}]);